import "./atoms-v2886.js";
import { memo as o } from "./atoms-v21087.js";
const m = o(() => window.ScrollTimeline !== void 0);
export {
  m as supportsScrollTimeline
};
